/* eslint-disable react/no-unescaped-entities */

import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import TextLink from 'components/TextLink';
import Alert, { AlertTypes } from 'components/Alert';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ReplaceButton = function ReplaceButton(_ref) {
  var onClick = _ref.onClick,
    children = _ref.children;
  return /*#__PURE__*/_jsx(TextLink, {
    onClick: onClick,
    as: "button",
    children: children
  });
};
var DeleteButton = function DeleteButton(_ref2) {
  var onClick = _ref2.onClick,
    children = _ref2.children;
  return /*#__PURE__*/_jsx(TextLink, {
    onClick: onClick,
    as: "button",
    children: children
  });
};
var ProcessingAlert = function ProcessingAlert(_ref3) {
  var isEditMode = _ref3.isEditMode,
    fileName = _ref3.fileName,
    onReplace = _ref3.onReplace,
    onDelete = _ref3.onDelete;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(Alert, {
    type: AlertTypes.FAIL,
    children: isEditMode ? /*#__PURE__*/_jsxs(Trans, {
      t: t,
      i18nKey: "alert_edit_asset_processing_error_replace",
      name: fileName,
      children: ["There was an error when processing the file \"", fileName, "\". Please", ' ', /*#__PURE__*/_jsx(ReplaceButton, {
        onClick: onReplace,
        children: "upload a new file"
      }), "."]
    }) : /*#__PURE__*/_jsxs(Trans, {
      t: t,
      i18nKey: "alert_asset_processing_error_replace_or_delete",
      name: fileName,
      children: ["There was an error when processing the file \"", fileName, "\". Please", ' ', /*#__PURE__*/_jsx(ReplaceButton, {
        onClick: onReplace,
        children: "upload a new file"
      }), "or", /*#__PURE__*/_jsx(DeleteButton, {
        onClick: onDelete,
        children: "delete the asset"
      }), "."]
    })
  });
};
export default ProcessingAlert;